import React, { useState } from 'react';
import type { FC } from 'react';
import { ChooseAppCreationSource } from '../ChooseAppCreationSource.js';
import { ChooseTemplate } from '../ChooseTemplate.js';
import { TemplateSource } from '../../parse-command-options.js';

interface ChooseTemplateFlowProps {
  onTemplateChoose: (template: TemplateSource) => void;
}

export const ChooseTemplateFlow: FC<ChooseTemplateFlowProps> = ({
  onTemplateChoose,
}) => {
  const [shouldSelectTemplate, setShouldSelectTemplate] = useState(false);

  return (
    <>
      <ChooseAppCreationSource
        onSelected={(source) => {
          if (source === 'basic') {
            onTemplateChoose(TemplateSource.Default());
          } else {
            setShouldSelectTemplate(true);
          }
        }}
      />

      {shouldSelectTemplate && (
        <ChooseTemplate
          onSelected={(template) => {
            onTemplateChoose(TemplateSource.App(template));
          }}
        />
      )}
    </>
  );
};
